import LocalizedStrings from 'react-localization';

const languages = {
  nl: {
    fullyBooked: 'Volzet',
    contactTitle: 'Contactgegevens',
    contactDescription: 'Vul alle contactgegevens in.',
    contactPlayerName: 'Naam Speler',
    contactPlayerFirstname: 'Voornaam Speler',
    contactDateOfBirth: 'Geboortedatum speler (dd/mm/jjjj)',
    contactPhone1: 'Telefoonnummer 1',
    contactPhone2: 'Telefoonnummer 2',
    contactEmail: 'E-mailadres',
    contactStreet: 'Straat + Huisnummer',
    contactCity: 'Postcode + Gemeente',
    contactClub: 'Club',
    contactRemarks: 'Opmerkingen',
    registerNewsletter: 'Ik schrijf me in voor de RSCA Newsletter',
    acceptTerms:
      'Ik ga akkoord met de <a style="color: rgb(124, 58, 237); text-decoration: underline" target="_blank" href="https://www.purplestart.be/terms">algemene voorwaarden</a>',
    acceptTermsRequired: 'Gelieve akkoord te gaan met de algemene voorwaarden.',
    eventsTitle: 'Voetbalstages',
    eventsDescription: '',
    eventsFormTitle: 'Schrijf je in voor onze voetbalstages',
    eventsFormDescription: 'Vink de stages aan waaraan je wenst deel te nemen.',
    eventsSelect: 'Selecteer alle stages',
    trainingTitle: 'Trainingssessies',
    trainingDescription: 'Kies één van de onderstaande modules',
    orderError:
      'Er is een probleem opgetreden bij de reservatie. Probeer het opnieuw of contacteer ons via <a href="mailto:info@purplestart.be"><strong>info@purplestart.be</strong></a>',
    paymentTitle: 'Betaling',
    paymentDescriptionEvents:
      'Om de geselecteerde stages te reserveren dient u de betaling online af te ronden.',
    paymentDescriptionSessions:
      'Om de geselecteerde sessies te reserveren dient u de betaling online af te ronden.',
    paymentSummaryTitle: 'Samenvatting',
    paymentSummaryNothingSelectedEvents:
      'Gelieve tenminsten één stage te selecteren.',
    paymentSummaryNothingSelectedSessions:
      'Gelieve tenminsten één sessie te selecteren.',
    paymentSummaryPriceEvents:
      'De geselecteerde stages komen neer op een totaal van <strong>{1}</strong>.',
    paymentSummaryPriceSessions:
      'De geselecteerde sessies komen neer op een totaal van <strong>{1}</strong>.',
    paymentButton: 'Nu Betalen',
    registrationTypeTrialSingle: '{0} Proefsessie',
    registrationTypeTrial: '{0} Proefsessies',
    registrationTypePerSession: 'Per sessie',
    registrationTypePerMonth: 'Maandelijks',
    sessionsByDateTitle: 'Schrijf je in per sessie',
    sessionsByDateDescription:
      'De prijs per sessie bedraagt <strong>{0}</strong>. Bij het inschrijven van minimaal <strong>{1}</strong> sessies is de prijs <strong>{2}</strong>.',
    sessionsByMonthSelect: 'Selecteer alle maanden',
    sessionsByMonthTitle: 'Reserveer maandelijks',
    sessionsByMonthDescription:
      'De inschrijvingen voor één maand bedragen <strong>{0}</strong> per sessie. Indien u inschrijft voor minimum {1} maand dan bedraagt de prijs <strong>{2}</strong> per sessie.',
    sessionsByTrialTitle: 'Reserveer {0} proefsessie(s)',
    sessionsByTrialDescription:
      'De totaalprijs voor de proefsessies bedraagt <strong>{0}</strong>.',
    sessionsByTrialDescriptionDates:
      'De proefsessies worden op {0} opeenvolgende data geboekt.',
    validationRequired: 'Dit is een verplicht veld',
    validationEmail: 'Gelieve een geldig e-mailadres in te vullen',
  },
  fr: {
    fullyBooked: 'Complet',
    contactTitle: 'Coordonnées de contact',
    contactDescription: 'Veuillez remplir toutes les coordonnées.',
    contactPlayerName: 'Nom Joueur',
    contactPlayerFirstname: 'Prénom Joueur',
    contactDateOfBirth: 'Date de naissance (jj/mm/aaaa)',
    contactPhone1: 'Numéro de téléphone 1',
    contactPhone2: 'Numéro de téléphone 2',
    contactEmail: 'E-mail',
    contactStreet: 'Adresse (rue + numéro de maison)',
    contactCity: 'Code postal + Ville',
    contactClub: 'Club',
    contactRemarks: 'Remarques',
    registerNewsletter: "Je m'abonne au RSCA Newsletter ",
    acceptTerms:
      'J\'accepte <a style="color: rgb(124, 58, 237); text-decoration: underline" target="_blank" href="https://www.purplestart.be/terms?lang=fr">les termes et conditions</a>',
    acceptTermsRequired: 'Veuillez accepter les termes et conditions.',
    trainingTitle: "Séances d'entraînement",
    trainingDescription: "Choisissez l'un des modules ci-dessous",
    eventsTitle: 'Stages de foot',
    eventsDescription: '',
    eventsFormTitle: 'Inscris-toi à nos stages de foot',
    eventsFormDescription:
      'Veuillez cocher les stages auxquels vous souhaitez participer.',
    eventsSelect: 'Sélectionner Tout',
    orderError:
      'Il y a eu un problème avec la réservation. Veuillez réessayer ou nous contacter: <a href="mailto:info@purplestart.be"><strong>info@purplestart.be</strong></a>',
    paymentTitle: 'Paiement',
    paymentDescriptionEvents:
      'Pour réserver les dates choisies, vous devez effectuer le paiement en ligne.',
    paymentDescriptionSessions:
      'Pour réserver les dates choisies, vous devez effectuer le paiement en ligne.',
    paymentSummaryTitle: 'Résumé',
    paymentSummaryNothingSelectedEvents: 'Veuillez choisir au moins un stage.',
    paymentSummaryNothingSelectedSessions:
      'Veuillez choisir au moins une séance.',
    paymentSummaryPriceEvents:
      "Les stages sélectionnées s'élèvent à un total de <strong>{1}</strong>.",
    paymentSummaryPriceSessions:
      "Les séances sélectionnées s'élèvent à un total de <strong>{1}</strong>.",
    paymentButton: 'Payer',
    registrationTypeTrialSingle: "{0} séance d'essai",
    registrationTypeTrial: "{0} séances d'essai",
    registrationTypePerSession: 'Par séance',
    registrationTypePerMonth: 'Mensuel',
    sessionsByDateTitle: "S'inscrire par séance",
    sessionsByDateDescription:
      'Le prix par séance est de <strong>{0}</strong>. Si vous vous inscrivez pour un minimum de <strong>{1}</strong> séancezs, le prix est de <strong>{2}</strong>.',
    sessionsByMonthSelect: 'Sélectionner Tout',
    sessionsByMonthTitle: 'Réserver mensuellement',
    sessionsByMonthDescription:
      'Les inscriptions pour un mois coûtent <strong>{0}</strong> par séance. Si vous vous inscrivez pour au moins {1} mois, le prix est de <strong>{2}</strong> par séance.',
    sessionsByTrialTitle: "Réserver {0} séance(s) d'essai",
    sessionsByTrialDescription:
      "Le prix total des séances d'essai est de <strong>{0}</strong>. Les séances d'essai sont réservées à 2 dates consécutives.",
    sessionsByTrialDescriptionDates:
      "Les séances d'essai sont réservées à {0} dates consécutives.",
    validationRequired: 'Ce champ est obligatoire',
    validationEmail: 'Veuillez remplir une adresse mail valide',
  },
};

const strings = new LocalizedStrings(languages);

export { languages, strings };

export function setLanguage(lng) {
  strings.setLanguage(lng);
}

export function getLanguage() {
  strings.getLanguage();
}
